import React from 'react';
import { v2BrandLogo, whatsappUrl } from '../../pages/SiteRefreshPreview/siteRefreshContent';
import napalmLogo from '../Menu/images/napalm_logo.png';

const PreviewCta = () => (
  <section className="site-refresh__section site-refresh__section--cta" id="contato">
    <div className="site-refresh__shell">
      <div className="site-refresh__cta-panel">
      <img src={napalmLogo} alt="" className="site-refresh__cta-flame" aria-hidden="true" />
        <div className="site-refresh__cta-copy">
          <h2 className="site-refresh__cta-title">
            Pronto para criar algo <span className="site-refresh__accent-word">impossível</span>?
          </h2>
          <p className="site-refresh__intro">
            Vamos tirar sua próxima ideia do papel e do óbvio.
          </p>
        </div>
        <div className="site-refresh__cta-actions">
          <a
            href={whatsappUrl}
            className="site-refresh__button site-refresh__button--primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Vamos conversar
            <span className="site-refresh__arrow" aria-hidden="true">
              →
            </span>
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default PreviewCta;
